import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";
function convert24hrTo12hr(hour) {
    hour = parseInt(hour); // Ensure the hour is an integer
    if (hour === 0) {
        return "12 AM";
    } else if (1 <= hour && hour < 12) {
        return `${hour} AM`;
    } else if (hour === 12) {
        return "12 PM";
    } else if (13 <= hour && hour <= 23) {
        return `${hour - 12} PM`;
    } else {
        throw new Error("Invalid hour value");
    }
}
class LineChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chart_data:[]
        };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);
        var transactionData = this.props.data
        transactionData.forEach(transaction => {
            transaction["Transaction Time"] = convert24hrTo12hr(transaction["Transaction Time"]);
        });
        this.setState({
            chart_data:transactionData
        })

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }
    handleClick(e){
        console.log(e);
    }
    render() {   //console.log(this.props.data);
        var graphs = [];
        var valueAxes = [];
        var l =1;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        var pos = "left";
        var line_color = "#4cd9c0";
        this.props.y_axis.map(function (pl, index) {
            if(l>1) { pos = "right"; line_color = "#7b43a2";}
            graphs.push({
                "valueAxis": "v"+l,
                "bullet": "round",
                "bulletBorderAlpha": 1,
                "bulletColor": "#FFFFFF",
                "bulletSize": 3,
                // "balloon": {
                //     "enabled": true,
                //     "horizontalPadding":2
                // },
                "hideBulletsCount": 50,
                "lineThickness": 2,
                "balloonText": "<span style='font-size:9px; color:#000000;'>[[title]]: [[value]]</br>[[lableText]]</span>",
                "title": pl,
                "useLineColorForBulletBorder": true,
                "valueField": pl,
                "lineColor": line_color // Set line color to red

            });
            valueAxes.push({
                "id":"v"+l,
                "axisThickness": 2,
                "position": pos,
                "axisColor": "#E3E3E3",
                "title": pl,
                "axisAlpha": 1,
                // "titleBold": false,
                "titleColor": "#333333",
                "titleFontSize": 11,
                "precision":0
            })
            l++;
        })

        const config = {
            "type": "serial",
            "theme": "light",
            "legend": {
                "useGraphSettings": true,
                // "verticalGap":4,
                "valueFunction": function(graphDataItem, valueText) {
                    return "";
                 },
                "align": "center",
                "autoMargins": false,
                "equalWidths": false,
                "valueAlign": "left",
                "valueWidth": 10,
                "fontSize":8,
                "marginLeft":0,
                "marginRight":0,
                "marginTop":0,
                "marginBottom":0,
                "verticalGap":5,
                "position":"top"
            },
            "marginTop": 5,
            "marginRight": 10,
            "marginLeft": 20,
            "autoMarginOffset": 20,
            "mouseWheelZoomEnabled": true,
            "dataProvider": this.state.chart_data,
            "synchronizeGrid":true,
            "valueAxes": valueAxes,
            "graphs": graphs,
            "chartScrollbar": {
                "enabled":false,
                "graph": "g1",
                "autoHide": true,
                "oppositeAxis": false,
                "offset":30,
                "scrollbarHeight": 80,
                "backgroundAlpha": 0,
                "selectedBackgroundAlpha": 0.1,
                "selectedBackgroundColor": "#888888",
                "graphFillAlpha": 0,
                "graphLineAlpha": 0.5,
                "selectedGraphFillAlpha": 0,
                "selectedGraphLineAlpha": 1,
                "autoGridCount": true,
                "color":"#AAAAAA"
            },
            "chartCursor": {
                "pan": true,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha":1,
                "cursorColor":"#258cbb",
                "limitToGraph":"g1",
                "valueLineAlpha":0.2,
                "valueZoomable": true,
                "zoomable": true
            },
            "valueScrollbar":{
                "enabled" :false,
                "oppositeAxis": false,
                "offset":50,
                "scrollbarHeight":10
            },
            "categoryField": this.props.x_axis,
            "categoryAxis": {
                //"parseDates": true,
                "dashLength": 1,
                "minorGridEnabled": false,
                //"labelRotation": 25,
                "fontSize":8,
                //"minPeriod":"MM"
            },
//             "export": {
//                 "enabled": true,
//                 "fileName": fileName.replace(/ /g,"_"),
//                 "menu": [ {
//                 "class": "export-main",
//                 "menu": ["XLSX", "CSV" ],
//               } ]
//             },
            listeners:[{
                    "event": "clickGraphItem",
                    "method": (e)=>{this.handleClick(e.item)}
                }]
    };
        return (
            <div className ="chart_div">
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight }} options={config} />
            </div>
        );
    }
}

export default LineChart;